require.context(`../../old_images`, true)

import "../../stylesheets/old-application.scss"

import "../old-application/application"
